module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAAGXcA1uAAAABGdBTUEAALGPC/xhBQAAAC5JREFUSA1jYBgFZITAfzL0jGrBGwKjQYo3eEa6JCh5jCaRkZ4KRv0/GgIDFwIAj+kD/RX9HtAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/24pxPoint.png
// module id = 255
// module chunks = 0